import React from 'react'

import formatDate from 'helpers/dateTimeFormatter'
import { EditableCell } from 'components/DataTableTest'

export const creditcardList = (t) => [
	{
		Header: t('common.fields.code'),
		accessor: 'clientNumber'
	}, {
		Header: t('common.fields.name'),
		accessor: 'name'
	}
]

export const defaultOrder = (t) => [
	{
		Header: t('common.fields.code'),
		accessor: 'Nummer',
		width: '120'
	}, {
		Header: t('common.fields.name'),
		accessor: 'Bezeichnung',
		Cell: '',
		aggregate: vals => vals[0],
		Aggregated: row => <span>{row.value}</span>,
		width: '170'
	}, {
		Header: t('credit_client_section.strings.information'),
		accessor: 'Info',
		Cell: '',
		aggregate: vals => vals[0],
		Aggregated: row => <span>{row.value}</span>,
		width: '180'
	}, {
		Header: t('credit_client_section.strings.days'),
		accessor: 'Tage',
		aggregate: vals => vals[0],
		Aggregated: row => <span>{row.value}</span>,
		width: 'auto'
	}, {
		Header: t('credit_client_section.strings.amount'),
		accessor: 'Menge',
		aggregate: vals => vals[0],
		Aggregated: row => <span>{row.value}</span>,
		width: 'auto'
	}, {
		Header: t('credit_client_section.strings.new_amount'),
		accessor: 'MengeNeu',
		aggregate: vals => vals[0],
		Aggregated: row => <span>{row.value}</span>,
		width: 'auto'
	}, {
		Header: t('credit_client_section.strings.minimum'),
		accessor: 'Minimum',
		aggregate: vals => vals[0],
		Aggregated: row => <span>{row.value}</span>,
		width: 'auto'
	}, {
		Header: t('credit_client_section.strings.maximum'),
		accessor: 'Maximun',
		aggregate: vals => vals[0],
		Aggregated: row => <span>{row.value}</span>,
		width: 'auto'
	}, {
		Header: t('credit_client_section.strings.alloted'),
		accessor: 'Alloted',
		aggregate: vals => vals[0],
		Aggregated: row => <span>{row.value}</span>,
		width: 'auto'
	}
]

export const defaultOrder1 = (t) => [
	{
		Header: t('common.fields.code'),
		accessor: 'Nummer',
		Aggregated: row => '',
		width: 140
	}, {
		Header: t('common.fields.name'),
		accessor: 'Bezeichnung',
		Cell: '',
		aggregate: vals => vals[0],
		Aggregated: row => `${row.value}`,
		width: 150
	}, {
		Header: t('credit_client_section.strings.information'),
		accessor: 'Info',
		Cell: '',
		aggregate: vals => vals[0] ? vals[0] : '',
		Aggregated: row => `${row.value}`,
		width: 170
	}, {
		Header: t('credit_client_section.strings.days'),
		accessor: 'Tage',
		aggregate: vals => vals[0] ? vals[0] : '',
		Aggregated: row => `${row.value}`,
		width: 70
	}, {
		Header: t('credit_client_section.strings.amount'),
		accessor: 'Menge',
		aggregate: vals => vals[0] ? vals[0] : '',
		Aggregated: row => `${row.value}`,
		width: 70
	}, {
		Header: t('credit_client_section.strings.new_amount'),
		accessor: 'MengeNeu',
		aggregate: vals => vals[0] ? vals[0] : '',
		Aggregated: row => `${row.value}`,
		width: 70
	}, {
		Header: t('credit_client_section.strings.minimum'),
		accessor: 'Minimum',
		aggregate: vals => vals[0] ? vals[0] : '',
		Aggregated: row => `${row.value}`,
		width: 70
	}, {
		Header: t('credit_client_section.strings.maximum'),
		accessor: 'Maximun',
		aggregate: vals => vals[0] ? vals[0] : '',
		Aggregated: row => `${row.value}`,
		width: 70
	}, {
		Header: t('credit_client_section.strings.alloted'),
		accessor: 'Alloted',
		aggregate: vals => vals[0] ? vals[0] : '',
		Aggregated: row => `${row.value}`,
		width: 70
	}
]

export const dayOrder = (t) => [
	{
		Header: t('common.fields.date'),
		accessor: 'date',
		Cell: ({ value }) => formatDate(value, 'DD.MM.YYYY'),
		width: 100
	}, {
		Header: t('common.fields.code'),
		accessor: 'product.code',
		width: 140
	}, {
		Header: t('common.fields.name'),
		accessor: 'product.name',
		width: 140
	}, {
		Header: t('credit_client_section.strings.amount'),
		accessor: 'amount'
	}, {
		Header: t('credit_client_section.strings.new_amount'),
		accessor: 'proposedAmount'
	}, {
		Header: t('credit_client_section.strings.minimum'),
		accessor: 'minAmount'
	}, {
		Header: t('credit_client_section.strings.maximum'),
		accessor: 'maxAmount'
	}, {
		Header: t('credit_client_section.strings.alloted'),
		accessor: 'allottedAmount'
	}
]

export const deliveryNotes = (t) => [
	{
		Header: t('common.fields.date'),
		accessor: 'date'
	}, {
		Header: t('credit_client_section.strings.delivery_note_number'),
		accessor: 'number'
	}, {
		Header: t('credit_client_section.strings.total'),
		accessor: 'total'
	}
]

export const defaultOrderModal = (t) => [
	{
		Header: '',
		accessor: 'amountCaption',
		width: 150
	}, {
		Header: t('common.dates.monday'),
		accessor: 'monday',
		Cell: EditableCell,
		width: 80
	}, {
		Header: t('common.dates.tuesday'),
		accessor: 'tuesday',
		Cell: EditableCell,
		width: 80
	}, {
		Header: t('common.dates.wednesday'),
		accessor: 'wednesday',
		Cell: EditableCell,
		width: 80
	}, {
		Header: t('common.dates.thursday'),
		accessor: 'thursday',
		Cell: EditableCell,
		width: 80
	}, {
		Header: t('common.dates.friday'),
		accessor: 'friday',
		Cell: EditableCell,
		width: 80
	}, {
		Header: t('common.dates.saturday'),
		accessor: 'saturday',
		Cell: EditableCell,
		width: 80
	}, {
		Header: t('common.dates.sunday'),
		accessor: 'sunday',
		Cell: EditableCell,
		width: 80
	}
]
